import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CsControlsModule } from '@cbuild/controls';
import { AiAssistantComponent } from './ai-assistant.component';

@NgModule({
  declarations: [AiAssistantComponent],
  imports: [CommonModule, CsControlsModule, FormsModule, ReactiveFormsModule],
  exports: [AiAssistantComponent, CsControlsModule, FormsModule, ReactiveFormsModule]
})
export class AiAssistantModule {}
